import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { cancelled, put } from 'redux-saga/effects';

import * as D from '../../deps';
import { search } from '../../services';
import { getTypesForSearchScope } from '../../utils';

const CancelToken = axios.CancelToken;

// @ts-expect-error TS(7031) FIXME: Binding element 'payload' implicitly has an 'any' ... Remove this comment to see the full error message
export function* getSearchResults({ payload }) {
  const searchTypes = getTypesForSearchScope(payload.searchFilter);
  const source = CancelToken.source();
  const searchData = Object.assign(
    {},
    payload,
    { searchTypes, query: payload.searchTerm },
    { cancelToken: source.token },
  );
  if (isEmpty(searchData.query)) return;
  try {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    return yield D.tryCall(search, searchData);
  } finally {
    // @ts-expect-error TS(7057) FIXME: 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
    if (yield cancelled()) {
      source.cancel('cancelled');
    }
  }
}

// @ts-expect-error TS(7031) FIXME: Binding element 'pathname' implicitly has an 'any'... Remove this comment to see the full error message
export function* closeSearch({ payload: { pathname } }) {
  if (!D.isInSearchPath(pathname)) {
    yield put(D.Actions.UseCases.closeSearch());
  }
}
